import { useEffect } from "react";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { useRouter } from "../useRouter";
import { applyCheckPromotionCode, checkPromotionTrial } from "src/service/pay";
import {
  hasBillAtom,
  hasSiteAtom,
  navStepAtom,
  productKeyAtom,
} from "src/atoms";
import { useRecoilState } from "recoil";
import { useGetMyServiceList } from "../api/product/useGetMyServiceList";
import { notifyError } from "src/components/Common/Toast";
import { useGetPayUnregisterBill } from "../api/bill/useGetPayUnregisterBill";
import { useGetPromotionUnregisterBill } from "../api/bill/useGetPromotionUnregisterBill";

// 구매한 사이트가 있는지 확인하는 Hook
export function useCheckHasBill() {
  const route = useRouter();
  const { serviceList } = useGetMyServiceList({});
  const { unregisterPayList } = useGetPayUnregisterBill({});
  const { unregisterPromotionList } = useGetPromotionUnregisterBill({});
  const [hasBill, setHasBill] = useRecoilState(hasBillAtom);
  const [navStep, setNavStep] = useRecoilState(navStepAtom);
  const [hasSite, setHasSite] = useRecoilState(hasSiteAtom);
  const [productName, setProductName] = useRecoilState(productKeyAtom);
  useEffect(() => {
    const init = async () => {
      try {
        // 전역상태 확인
        // setNavStep(0);
        setHasSite(false);
        setHasBill(false);
        if (
          serviceList?.length === 0 &&
          unregisterPayList &&
          unregisterPromotionList
        ) {
          try {
            // 사이트를 생성할 것이 남아 있다면
            // const unregisterPay = await getServiceUnregisterBill({
            //   billType: "PAY",
            //   product: getProductFromSessionStorage(),
            // });

            // const unregisterPromotion = await getServiceUnregisterBill({
            //   billType: "PROMOTION",
            //   product: getProductFromSessionStorage(),
            // });
            if (unregisterPayList.length > 0) {
              setHasBill(true);
            } else if (unregisterPromotionList.length > 0) {
              setNavStep(3);
              setHasBill(true);
            } else {
              let makeType = "";
              let result = await applyCheckPromotionCode({
                product: getProductFromSessionStorage(),
              });
              console.log("applyCheckPromotionCode", result);
              if (result) {
                if (result === "C_APPROVED") {
                  // window.location.href = `${process.env.PUBLIC_URL}/${lang}/site/promotion`;
                  route.goSitePromotion({});
                } else {
                  makeType = result;
                }
              } else {
                result = await checkPromotionTrial({
                  product: getProductFromSessionStorage(),
                });

                if (result === "T_APPROVED") {
                  setHasBill(true);
                }
              }
            }
          } catch (error) {
            console.log("error", error);
            route.goSiteType();
          }
        } else {
          setHasSite(true);
          setHasBill(true);
        }
      } catch (error: any) {
        if (error?.errorCode && error?.errorMessage) {
          notifyError(error.errorMessage);
        }
      }
    };

    if (unregisterPayList && unregisterPromotionList) init();
  }, [productName, unregisterPayList, unregisterPromotionList]);
}
